import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AbstractInputComponent } from '@shared/form-elements/input/abstract-input/abstract-input.component';
import { ControlToKeyNamePipe } from '@shared/form-elements/pipes/control-to-key-name.pipe';
import { TranslateSafePipe } from '../../translate-safe/translate-safe.pipe';
import { IconButtonComponent } from '../../button/icon-button/icon-button.component';
import { NgClass } from '@angular/common';

@UntilDestroy()
@Component({
    selector: 'app-quantity',
    templateUrl: './quantity.component.html',
    styleUrls: ['./quantity.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, FormsModule, ReactiveFormsModule, IconButtonComponent, TranslateSafePipe, ControlToKeyNamePipe]
})
export class QuantityComponent extends AbstractInputComponent implements OnInit {
    @Input() max: number = 999;

    public increase(): void {
        this.control.setValue(this.control.value + 1);
    }

    public decrease(): void {
        this.control.setValue(this.control.value - 1);
    }

    public get formControl(): UntypedFormControl {
        return this.control as UntypedFormControl;
    }

    ngOnInit(): void {
        // Makes it not possible to manually type in negative numbers
        this.control.valueChanges.pipe(untilDestroyed(this)).subscribe(value => {
            if (value < 1) {
                this.control.patchValue(1);
                return;
            }
            if (this.max > 0 && value > this.max) {
                this.control.patchValue(this.max);
            }
        });
    }
}
